// 是否是对象
export const isObject = obj => {
  return Object.prototype.toString.call(obj) === "[object Object]";
};

// 是否是字符串
export const isString = obj => {
  return Object.prototype.toString.call(obj) === "[object String]";
};

// 是否是方法
export const isFunction = obj => {
  return Object.prototype.toString.call(obj) === "[object Function]";
};



// WEBPACK FOOTER //
// ./src/utils/tools/type.js